import { ReactNode } from 'react';

import { PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Flex, Button, Colors } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Form, FormListFieldData, Typography } from 'antd';

interface Props {
  title: string;
  description?: string;
  fieldName: string;
  addItemButtonText: string;
  renderItems: (
    field: FormListFieldData,
    index: number,
    onRemove?: (index: number) => void,
  ) => ReactNode;
}
const BusinessEntityFormList = (props: Props) => {
  const { title, description, fieldName, renderItems, addItemButtonText } = props;
  return (
    <Flex
      style={{
        width: '100%',
      }}
    >
      <Form.List name={fieldName}>
        {(fields, { add, remove }) => {
          const onRemove = (index: number) => {
            remove(index);
          };
          return (
            <Flex
              direction="column"
              gap={4}
              align="flex-start"
              style={{
                width: '100%',
              }}
            >
              <Flex
                gap={4}
                align="center"
                style={{
                  width: '100%',
                }}
              >
                <Typography.Text style={{ color: Colors.gray800 }}>{title}</Typography.Text>
                {description && (
                  <QuestionCircleOutlined
                    width={14}
                    height={14}
                    style={{
                      color: colorTokens.iconDefault,
                    }}
                  />
                )}
              </Flex>
              <Flex
                gap={4}
                align="flex-start"
                direction="column"
                style={{
                  width: '100%',
                }}
              >
                <Flex
                  gap={4}
                  align="flex-start"
                  direction="column"
                  style={{
                    width: '100%',
                  }}
                >
                  {fields.map((field, index) => {
                    return renderItems(field, index, onRemove);
                  })}
                </Flex>
                <Button onClick={() => add()} icon={<PlusOutlined />}>
                  {addItemButtonText}
                </Button>
              </Flex>
            </Flex>
          );
        }}
      </Form.List>
    </Flex>
  );
};

export default BusinessEntityFormList;
